import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { firstAllowedPath } from "@/lib/nav";

function NoAccess() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="no-access-screen">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8 text-center">
        <h1 className="font-heading text-xl font-semibold text-slate-900">No modules assigned</h1>
        <p className="text-sm text-slate-500 mt-2">
          Your account ({user?.email}) doesn't have access to any module yet. Please ask a Super Admin to grant you permissions.
        </p>
        <button
          data-testid="no-access-logout-btn"
          onClick={logout}
          className="mt-6 w-full bg-slate-900 hover:bg-slate-800 text-white font-semibold py-2.5 rounded-lg transition-colors"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children, module = null, superAdminOnly = false, adminOnly = false }) {
  const { user, isSuper, canRead } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  const landing = firstAllowedPath(canRead, isSuper);

  if (superAdminOnly && !isSuper) {
    return landing ? <Navigate to={landing} replace /> : <NoAccess />;
  }
  if (adminOnly && !(isSuper || user.role === "admin")) {
    return landing ? <Navigate to={landing} replace /> : <NoAccess />;
  }
  if (module && !canRead(module)) {
    if (!landing || landing === location.pathname) return <NoAccess />;
    return <Navigate to={landing} replace />;
  }
  return children;
}
